/* eslint-disable indent */
/**
 * Created by akrio on 2018/3/26.
 */
import axios from "../utils/fetch";

/**
 * 创建新的 post 计划
 * http://schedulepost.dev.apphi.com/api/docs/#!/posts/Post_create
 * @param caption 说明
 * @param media_type 1: photo, 2: video, 8: album
 * @param cover_key app 内在 Scheduled Post 和 Posted 两个列表内显示的缩略图。
 * @param post_time 发布时间
 * @param delete_time 删除时间
 * @param tz_name 时区
 * @param additional_data 附加信息
 * @param medias 多媒体信息
 * {
            "key": "1/posts/e7c327a7248b04bf0765e8497054ae84", // string | required
            "type": 1, // number | required
                       // 1: photo, 2: video
            "cover_key": "1/posts/a5611efedb86ddb9cfba71b7c08fc816", // string | optional
                                                                     // 上传至 Instagram 时，video 使用的封面；
                                                                     // 仅当 type 为 video 时，为必填字段；
                                                                     // type 为 photo 是不需要。
            "usertags": [ // array | optional
                { // object | optional. 由 GET /instagram/users/search 接口获取
                    "user_id": "123458839283", // string | required
                    "username": "ig_test_2", // string | required
                    "position": [0.4890625, 0.6140625] // array | required
                                                       // Position relative to image where the tag should sit.
                }
            ]
        }
 * @param first_comment 首条评论
 * @param location 定位
 * @param story_url story url地址
 * @returns {AxiosPromise<T>}
 */
export function postSignature({
  caption = null,
  media_type,
  cover_key,
  post_time,
  delete_time = null,
  tz_name,
  additional_data = null,
  medias,
  first_comment = null,
  location = null,
  story_url = null,
}) {
  return axios.post("posts", {
    caption,
    media_type,
    cover_key,
    post_time,
    delete_time,
    tz_name,
    additional_data,
    medias,
    first_comment,
    location,
    story_url,
  });
}

/**
 * 添加media图片
 * http://schedulepost.dev.apphi.com/api/docs/#!/gallery/User_Gallery_create
 * @param cover_key 资源封面
 * @param media_key 资源
 * @param width 视频宽度
 * @param height 视频高度
 * @param format 格式
 * @param duration 时长
 * @returns {AxiosPromise<T>}
 */
export function addGallery({
  cover_key,
  media_key,
  width,
  height,
  format,
  duration = 0,
}) {
  return axios.post("gallery ", {
    cover_key,
    media_key,
    width,
    height,
    format,
    duration,
  });
}

/**
 * 删除media
 * @param ids 删除的media Id
 * @returns {*}
 */
export function delGallery({ ids }) {
  return axios.delete(`gallery/${ids}`);
}

/**
 * 获取用户图库资源
 * http://schedulepost.dev.apphi.com/api/docs/#!/gallery/User_Gallery_list
 * @param limit 查询个数
 * @param offset 查询偏移
 */
export function getGalleryList({ limit, offset }) {
  return axios.get("gallery", { params: { limit, offset } });
}

/**
 * 获取ins上保存列表
 * http://schedulepost.dev.apphi.com/api/docs/#!/instagram/User_Saved_Media_Model_list
 * @param limit 查询个数
 * @param offset 查询偏移
 */
export function getSavedList({ limit, offset }) {
  return axios.get("instagram/medias/saved", { params: { limit, offset } });
}
